import config from '../config.json';
import axios from 'axios';
import moment from 'moment';
import { LanguageService } from './LanguageService';

export class EntityService {
    constructor(lowerCasePluralEntityId){
        this.entityId = lowerCasePluralEntityId;
        this.languageService = new LanguageService();
    }

    get = async (data) => {
        return (await axios.get(`${config.BASE_URL}entities/${this.entityId}/${data.id}`, data)).data;
    }

    list = async (first, rowsPerPage, search, sortField, sortOrder) => {
        return (await axios.get(`${config.BASE_URL}entities/${this.entityId}?p=${first || 0},${rowsPerPage||25}${ (search || '') !== '' ? `&q=${search}` : ''}${ (sortField || '') !== '' && (sortOrder || '') !== '' ? `&s=${sortField},${sortOrder}` : ''}`)).data;
    }

    listAll = async () => {
        return (await axios.get(`${config.BASE_URL}entities/${this.entityId}?all=1`)).data;
    }

    create = async (data) => {
        return (await axios.post(`${config.BASE_URL}entities/${this.entityId}`, data)).data;
    }

    update = async (data) => {
        return (await axios.put(`${config.BASE_URL}entities/${this.entityId}/${data.id}`, data)).data;
    }
    
    delete = async (data) => {
        return (await axios.delete(`${config.BASE_URL}entities/${this.entityId}/${data.id}`, data)).data;
    }

    getAttributeLabel = (entity, attributeId) => {
        if(entity && entity.model && entity.model.attributes){
            const attribute = entity.model.attributes.find(a => a.id === attributeId);
            if(attribute && attribute.label){
                return attribute.label[this.languageService.getLanguage()];
            }
        }

        return attributeId;
    } 

    getAttributeFormatedValue = (entity, attributeId, instance) => {
        if(entity && entity.model && entity.model.attributes){
            const attribute = entity.model.attributes.find(a => a.id === attributeId);
            if(attribute)
            {
                let formatedValue = "";
                switch (attribute.type) {
                    case 'date':
                        formatedValue = moment.utc(instance[attributeId]).format('DD/MM/YYYY');//.utcOffset('-0300')
                        break;
                    case 'entity':
                        formatedValue = instance[`__${attributeId}`];
                        break;
                    default:
                        formatedValue = instance[attributeId];
                        break;
                }
                return formatedValue;
            }
        }

        return instance[attributeId];
    } 
}